import { Button, Form, Input, Table } from "antd";
import { IoTrashBinOutline } from "react-icons/io5";
import { FiEdit } from "react-icons/fi";
import Manage from "..";
import { useState } from "react";
import UpdateFirm from "./components/UpdateFirm";
import DeleteFirm from "./components/DeleteFirm";
import CreateWrapper from "./components/CreateWrapper";
import { useQuery } from "@tanstack/react-query";
import { handleFetchFirms } from "../../../api/firms";
import { ColumnsType } from "antd/es/table";
import { RiFilterOffLine } from "react-icons/ri";
const { Search } = Input;

export default function AllFirms() {
  const [updateModal, setUpdateModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selected, setSelected] = useState({});
  const [form] = Form.useForm();

  const initials = {
    name: "",
  };

  const [filters, setFilters] = useState<any>({ ...initials });

  const params = `name=${filters?.name}`;

  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: 10,
    total: 0,
  });

  const {
    data: firms,
    refetch,
    isLoading,
  } = useQuery({
    queryKey: ["firms", pagination.page, pagination.limit, params],
    queryFn: () =>
      handleFetchFirms({
        page: pagination.page,
        limit: pagination.limit,
        params,
      }),
  });

  const handlePageChange = (e: any) => {
    setPagination((prev: any) => ({
      ...prev,
      page: e.current,
      limit: e.pageSize,
    }));
  };

  const clearAllFilters = async () => {
    form.resetFields();
    setFilters({ ...initials });
    handleRefetch();
  };
  const handleRefetch = () => {
    refetch();
  };

  interface DataType {
    key: React.Key;
    name: string;
    age: number;
    address: string;
  }

  const columns: ColumnsType<DataType> = [
    {
      title: "S/N",
      width: 40,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">{index + 1}</span>
      ),
    },
    {
      title: "Name",
      width: 200,
      render: (record: any) => (
        <div className="text-gray-700 w-48">
          {record?.name === null ? "-" : record?.name}
        </div>
      ),
    },
    {
      title: "Address 1",
      width: 100,
      render: (record: any) => (
        <div className="text-gray-700 truncate w-36">
          {record?.address1 === null ? "-" : record?.address1}
        </div>
      ),
    },
    {
      title: "Address 2",
      width: 100,
      render: (record: any) => (
        <div className="text-gray-700 truncate w-36">
          {record?.address2 === null ? "-" : record?.address2}
        </div>
      ),
    },
    {
      title: "Address 3",
      width: 100,
      render: (record: any) => (
        <div className="text-gray-700 truncate w-36">
          {record?.address3 === null ? "-" : record?.address3}
        </div>
      ),
    },
    {
      title: "Address 4",
      width: 100,
      render: (record: any) => (
        <div className="text-gray-700 truncate w-36">
          {record?.address4 === null ? "-" : record?.address4}
        </div>
      ),
    },
    {
      title: "Website",
      width: 120,
      render: (record: any) => (
        <div className="text-gray-700 truncate w-36">
          {record?.website === null ? "-" : record?.website}
        </div>
      ),
    },

    {
      title: "Code",
      width: 50,
      render: (record: any) => (
        <div className="text-gray-700 w-10">
          {record?.code === null ? "-" : record?.code}
        </div>
      ),
    },
    {
      title: "Logo",
      width: 50,
      render: (record: any) => (
        <div className="border p-1">
          <img src={record?.logo} alt="" />
        </div>
      ),
    },
    {
      title: "Active",
      width: 50,
      render: (record: any) => (
        <div className="text-gray-700">
          {record?.isActive ? (
            <div className="text-green-500">Yes</div>
          ) : (
            <div className="text-red-500">No</div>
          )}
        </div>
      ),
    },
    {
      title: "Action",
      width: 40,
      render: (record: any) => (
        <div className="flex">
          <button
            onClick={() => {
              setSelected({
                ...record,
              });
              setUpdateModal(true);
            }}
            className="flex justify-center items-center text-gray-700 border rounded-md p-2 bg-gray-100 hover:bg-gray-200 cursor-pointer"
          >
            <FiEdit />
          </button>
          <button
            onClick={() => {
              setSelected({
                ...record,
              });
              setDeleteModal(true);
            }}
            className="flex justify-center items-center ml-1 text-gray-700 border rounded-md p-2 bg-red-100 hover:bg-red-200 cursor-pointer"
          >
            <IoTrashBinOutline />
          </button>
        </div>
      ),
    },
  ];

  return (
    <Manage
      title={"Companies"}
      subtitle={"All"}
      description={"List of all legal entities"}
      actions={
        <div className="flex">
          <div className="flex">
            <Form layout="inline" form={form}>
              <Form.Item name="name">
                <Search
                  placeholder="Search by name"
                  className="rounded-none"
                  allowClear
                  onSearch={(e: any) => {
                    setFilters({ ...filters, name: e });
                  }}
                />
              </Form.Item>
            </Form>
            <Button
              className="mr-2 -ml-4 focus:outline-none hover:bg-red-100 rounded-none"
              onClick={() => {
                clearAllFilters();
              }}
            >
              <RiFilterOffLine color="gray" />
            </Button>
          </div>
          <CreateWrapper refetch={refetch} />
        </div>
      }
    >
      <div className="grid gap-x-0 grid-cols-12">
        <div className="col-span-12 sm:col-span-12 md:col-span-12">
          <Table
            size="small"
            dataSource={firms?.records}
            columns={columns}
            scroll={{ y: 660, x: 0 }}
            rowKey="_id"
            style={{ fontSize: "12px" }}
            bordered
            pagination={{
              current: pagination?.page,
              pageSize: pagination?.limit,
              total: pagination?.total,
            }}
            onChange={(e: any) => handlePageChange(e)}
            loading={isLoading}
          />

          <UpdateFirm
            selected={selected}
            isVisible={updateModal}
            setVisible={setUpdateModal}
            refetch={handleFetchFirms}
          />

          <DeleteFirm
            selected={selected}
            isVisible={deleteModal}
            setDeleteModal={setDeleteModal}
          />
        </div>
      </div>
    </Manage>
  );
}
